import {VocabsRepository, VocabsIndividual} from './VocabsActions'

//Описание список элементов
const initialVocabsState = {
    state: "empty",         //Состояние загрузки элементов словарей объектных свойств
    rfilter: [],            //Обязательный фильтр, который накладывается для отбора элементов
    conditions: [],         //Массив условий отбора
    offset: 0,
    limit: 20,
    count: -1,              //Всего количество элементов. -1 данные по количеству не загружены.
    head: {"link": [], "vars": ["IRI", "dsn", "dsv"]},
    distinct: false,
    ordered: true,
    individual: {},         //Информация об индивидуале    
    items: [],              //Информация о загруженных списках индивидуалов,
    rdfTypes: [             //Типы элементов, элементы которых включены в словари объектных свойств
        "http://purl.org/dc/terms/LinguisticSystem",
        "http://purl.org/dc/terms/LicenseDocument",
        //"http://xmlns.com/foaf/0.1/Document", 
        "http://xmlns.com/foaf/0.1/Agent",
        "http://www.w3.org/2006/vcard/ns#VCard",
        //"http://purl.org/dc/terms/RightsStatement",
        //"http://purl.org/dc/terms/FileFormat",
        //"http://purl.org/dc/terms/Location",
        // "http://purl.org/dc/terms/Standard",
        // "http://purl.org/dc/terms/Frequency",
        //"http://purl.org/dc/terms/PeriodOfTime",
        //"http://purl.org/dc/terms/MediaType",
        //"http://purl.org/dc/terms/MediaTypeOrExtent",
        // "http://spdx.org/rdf/terms#Checksum"
    ],
};

export const vocabs = (state = { ...initialVocabsState} , action) => {
    switch (action.type) {
        case "VocabsRepository.EMPTY": 
            return{
                ...initialVocabsState,
                state: "empty"
            }
        case "VocabsRepository.LOAD_STARTED": 
            return{
                ...state,
                state: "load"
            }
        case "VocabsRepository.LOAD_ERROR": 
            return {
                ...state,
                state: "error",
                error: action.error
            };            
        case "VocabsRepository.LOAD_VOCABS": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                count: action.count, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                items: action.items,
                state: "loaded",
            };
        case "VocabsRepository.LOAD_NEXTVOCABS": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                items: [...state.items, ...action.items],
                state: "loaded",
            };
        case "VocabsRepository.ADD_VOCABS":
            const added = (state.items && Array.isArray(state.items))?[...state.items]: [];
            added.push({IRI: {type: "uri", value: action.iri},
                    dsn: {type: "literal", value: action.label}
            })
            return {
                ...state,
                items: added,
                state: "added"
            };
        case "VocabsRepository.REMOVE_VOCABS":
            const r = (state.items && Array.isArray(state.items))?[...state.items]: [];
            return {
                ...state,
                items: r.filter(scheme => scheme.IRI.value!=action.iri),
                state: "remove"
            };            
        case "VocabsRepository.CONDITIONS":
            return{
                ...state,
                items: [],
                offset: 0,
                conditions: action.conditions,
                state: "empty"
            }

        case "VocabsRepository.LOAD_DESCRIPTION":
            const nadesc = (state.items)?[...state.items]: [];
            for (let i=0; i<nadesc.length; i++) {
                const nadesc_a = nadesc[i];
                if ((nadesc_a.IRI) && (nadesc_a.IRI.value==action.IRI)){
                    nadesc_a.description = action.description;
                    //Если в отбор попадают с IRI дубликатами, то повторно вызывается загрузка описания
                    //break;
                }
            }
            return{
                ...state,
                items: nadesc,
            }
        default:
            return state;
    }
};

//Дефаултные значения для конкретной individual
const initialIndividualState = {
    state: "empty",     //Состояние схемы
    iri: null,
    head: {             //Заголовок полученных данных. См. результаты запроса в request.js для values_sparql
        link:[],        //Неполнятно зачем возвращается TODO выяснить в документации.
        vars:[]         //Переменные, которые определены в данных (по их названию пожно получить занчение)
    },
    predicates: [],     //Список загруженных предикатов
    languages:  [],     //Список доступных языков (языки для которых есть данные)
    values: [],
    details:{},         //Элементы с детальной информацией . Содержит объект с ключём URI, содержащий данные по объекту
};
export const vindivid = (state = { ...initialIndividualState}, action) => {
    switch (action.type) {
        case "VocabsIndividual.EMPTY":
            return{
                ...initialIndividualState,
            }
        case "VocabsIndividual.LOAD_STARTED":
            return{
                ...state,
                state: "load",
            }
        case "VocabsIndividual.LOAD_ERROR":
            return {
                ...initialIndividualState,
                state: "error",
                error: action.error
            };
        case "VocabsIndividual.LOAD_INDIVIDUAL":
            return {
                ...state,
                iri: action.iri,
                types: action.types,
                values: action.values,
                head: action.head, 
                predicates: action.predicates, 
                languages: action.languages,
                state: "loaded",
            };

        case "VocabsIndividual.ADD_NODES": {
            //Все доступные ID унонимных узлов
            const nodesId = Object.keys(action.contents);
            nodesId.forEach(nodeID => {
                for (let i=0; i<action.contents[nodeID].length; i++) {
                    if (action.contents[nodeID][i].object.type === "bnode" && nodesId.includes(action.contents[nodeID][i].object.value)){
                        action.contents[nodeID][i].values = action.contents[action.contents[nodeID][i].object.value];
                    }
                }
            });
            const svalues = (state.values && Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<svalues.length; i++) {
                if (action.contents[svalues[i].object.value])
                    svalues[i].values = action.contents[svalues[i].object.value];
            }
            //console.log("VocabsReducer.js ", "VocabsIndividual.ADD_NODES", JSON.stringify(svalues));
            return {
                ...state,
                values: svalues,
            };
        }

        case "VocabsIndividual.LOAD_LABELBYIRI":
            const lbi = (state.values && Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<lbi.length; i++) {
                if (lbi[i].object.value == action.iri)
                    lbi[i].labels = {head: action.head, values: action.values};
            }
            return {
            ...state,
            values: lbi,
        };
        case "VocabsIndividual.LOAD_CONCEPTS":
            return {
                ...state,
                concepts: action.concepts
            };

        case "VocabsIndividual.RELOAD_CONCEPT": 
            const rld = (Array.isArray(state.concepts))? [...state.concepts]:[];
            const rvd = (Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<rld.length; i++) {
                if (rld[i].object.value == action.iri)
                rld[i].values = action.values;
            };
            for (let i=0; i<rvd.length; i++) {
                if (rvd[i].object.value == action.iri)
                    rvd.values = action.values;
            };
            return {
                ...state,
                values: rvd,
                concepts: rld
            };     
        case "VocabsIndividual.LOAD_DETAIL":
            const ld = (state.values && Array.isArray(state.values))?[...state.values]:[];
            const {predicat, object } = action.triplet;
            for (let i=0; i<ld.length; i++) {
                if ((ld[i].object.value == object.value) && (ld[i].predicat.value == predicat.value)){
                    ld[i].values = action.values;
                    ld[i].state = action.state;
                    ld[i].head = action.head;
                }
            }
            const {details} = state;
            details[object.value] = {values: action.values, state: action.state, head: action.head};    
            return {
                ...state,
                values: ld,
                details
            };

        case "VocabsIndividual.LOAD_CONCEPT":
            const lc_detail = state.details;
            lc_detail[action.concept] = {values: action.values, state: action.state, head: action.head};    
            return {
                ...state,
                details: lc_detail
            };
            
        case "VocabsIndividual.REMOVE_CONCEPT":
            const rd = (state.concepts && Array.isArray(state.concepts))?[...state.concepts]: [];
            return {
                ...state,
                values: state.values.filter(value => value.object.value != action.iri),
                concepts: rd.filter(concept => concept.object.value!=action.iri)
            };                        

        case "VocabsIndividual.ADD_CONCEPT":
            const ad = (state.concepts && Array.isArray(state.concepts))?[...state.concepts]: [];
            ad[ad.length] = {predicat: {type: "uri", value: "https://www.w3.org/2009/08/skos-reference/skos.html#Concept"}, object: {type: "uri", value: action.iri}}
            return {
                ...state,
                concepts: ad
            };                                
            
        case "VocabsIndividual.GRAPH_STATE":
            const graphs = (state.graphs && Array.isArray(state.graphs))?[...state.graphs]:[];
            const hasGraph = graphs.filter(graph => graph.iri == action.iri).length>0; 
            if (hasGraph)
                for (let i=0; i<graphs.length; i++) {
                    if (graphs[i].iri == action.iri){
                        graphs[i].state = action.state;
                        break;
                    }
                }
            else 
                graphs.push({iri:action.iri, state: action.state});
            return {
                ...state,
                graphs
            }                         
    default:
            return state;
    }
}
